import { v4 as uuidv4 } from 'uuid';

export function FormInputText(props = {}, childrenComponents = []) {
	return {
		componentName: 'FormInputText',
		componentId: uuidv4(),
		props: Object.assign(
			{
				pointer: '',
				label: '',
				inputType: 'input',
				placeholder: '',
			},
			props,
		),
		childrenComponents,
	};
}
